import {action, observable} from 'mobx';
import Container, {Service} from 'typedi';
import {
  IResponseCompatDepartment,
  IResponseGetDepartmentAssignList,
  IResponseGetDepartmentById,
  IResponseGetDepartmentList,
} from '@/types';
import {
  CreateDepartmentDTO,
  DeleteDepartmentDTO,
  GetDepartmentByIdDTO,
  GetDepartmentCompactDTO,
  GetDepartmentListDTO,
  GetListDepartmentAssignDTO,
  GetProfileTenantDTO,
  HttpService,
  ResponseDTO,
  UpdateDepartmentDTO,
  UpdateProfileTenantDTO,
  GetAllBlockLimitHistoryDTO,
} from '@/shared';
import {
  GetDepartmentUsageDetailListDTO,
  GetExcelDepartmentUsageDetailListDTO,
  GetPdfDepartmentUsageDetailListDTO,
} from '@/shared/dto/department.dto';
import {IResponseGetDepartmentUsageDetailList} from '@/types/common/department';

@Service()
export class DepartmentService {
  @observable
  private httpService = Container.get(HttpService);

  @action.bound
  public async getDepartmentList(
    getDepartmentListDTO: GetDepartmentListDTO,
  ): Promise<ResponseDTO<IResponseGetDepartmentList>> {
    return this.httpService.request(getDepartmentListDTO);
  }

  public async getDepartmentUsageDetailList(
    getDepartmentUserUsageListDTO: GetDepartmentUsageDetailListDTO,
  ): Promise<ResponseDTO<IResponseGetDepartmentUsageDetailList>> {
    return this.httpService.request(getDepartmentUserUsageListDTO);
  }

  public async getDepartmentAssignList(
    getDepartmentListDTO: GetListDepartmentAssignDTO,
  ): Promise<ResponseDTO<IResponseGetDepartmentAssignList>> {
    return this.httpService.request(getDepartmentListDTO);
  }
  public async deleteDepartment(
    dto: DeleteDepartmentDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(dto);
  }
  public async updateDepartment(
    updateDepartmentDTO: UpdateDepartmentDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(updateDepartmentDTO);
  }
  public async createDepartment(
    createDepartmentDTO: CreateDepartmentDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(createDepartmentDTO);
  }
  public async getDepartmentById(
    getDepartmentByIdDTO: GetDepartmentByIdDTO,
  ): Promise<ResponseDTO<IResponseGetDepartmentById>> {
    return this.httpService.request(getDepartmentByIdDTO);
  }
  public async getTenant(dto: GetDepartmentByIdDTO): Promise<ResponseDTO> {
    return this.httpService.request(dto);
  }
  public async getProfileTenant(
    dto: GetProfileTenantDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(dto);
  }
  public async updateProfileTenant(
    dto: UpdateProfileTenantDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(dto);
  }
  public async getDepartmentCompact(
    getDepartmentCompactDTO: GetDepartmentCompactDTO,
  ): Promise<ResponseDTO<IResponseCompatDepartment[]>> {
    return this.httpService.request(getDepartmentCompactDTO);
  }

  public async getExcelDepartmentUsageDetailList(
    getExcelDepartmentUserUsageListDTO: GetExcelDepartmentUsageDetailListDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(getExcelDepartmentUserUsageListDTO);
  }

  public async getPdfDepartmentUsageDetailList(
    getPdfDepartmentUserUsageListDTO: GetPdfDepartmentUsageDetailListDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(getPdfDepartmentUserUsageListDTO);
  }

  public async getAllBlockLimitHistory(
    getAllBlockLimitHistoryDTO: GetAllBlockLimitHistoryDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(getAllBlockLimitHistoryDTO);
  }
}
